import {Injectable, OnDestroy} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable, Subject, timer} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {environment} from '@env/environment';
import {WorkerScheduleStatus} from '@app/domain/worker-schedule-status';

@Injectable({providedIn: 'root'})
export class WorkerScheduleService implements OnDestroy {
    static readonly SESSION_ENDED = 'WORK_SCHEDULE_SESSION_ENDED';
    static readonly ACTIONS_RESTRICTED = 'WORK_SCHEDULE_ACTIONS_RESTRICTED';

    private readonly statusSubject = new BehaviorSubject<WorkerScheduleStatus>(null);
    private readonly timerReset$ = new Subject<void>();
    private readonly destroy$ = new Subject<void>();

    readonly status$ = this.statusSubject.asObservable();

    constructor(private http: HttpClient) {}

    apply(status: WorkerScheduleStatus): void {
        this.timerReset$.next();
        this.statusSubject.next(status || null);
        if (!status?.asignado || !status.proximoCambio) {
            return;
        }
        const delay = Math.max(250, new Date(status.proximoCambio).getTime() - Date.now() + 250);
        timer(delay).pipe(takeUntil(this.timerReset$), takeUntil(this.destroy$))
            .subscribe(() => this.refresh().subscribe(nextStatus => this.apply(nextStatus)));
    }

    refresh(): Observable<WorkerScheduleStatus> {
        return this.http.get<WorkerScheduleStatus>(`${environment.endpointApi}/work-schedule/status`, {
            headers: {hideLoader: 'true', hideErrorMessage: 'true'}
        });
    }

    clear(): void {
        this.timerReset$.next();
        this.statusSubject.next(null);
    }

    isCode(error: any, code: string): boolean {
        return error?.error?.code === code;
    }

    ngOnDestroy(): void {
        this.timerReset$.next();
        this.destroy$.next();
        this.destroy$.complete();
    }
}
